import React, { useEffect, useRef, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import GraficaPotencia from "components/chart/ChartPotencia";
import { Col, Row } from "reactstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import { avantSolarApi } from "api/authApi";
import Alert from "components/alert";
import SpinnerAvantsolar from "components/utils/spinner";
import { tamanioGrafica } from "utils/generalFunctions";
import { convertirFechaInputFecha } from "utils/generalFunctions";
import Footer from "components/Footer/Footer";

var ps;

function GraficaPotenciaInversor(props) {
  const mainPanel = React.useRef();
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const location = useLocation();
  const [inversoresSelectCopia, setInversoresSelectCopia] = useState(null);
  const [contadoresSelectCopia, setContadoresSelectCopia] = useState(null);
  const [inversoresSelect1, setInversoresSelect1] = useState(null);
  const [inversoresSelect2, setInversoresSelect2] = useState(null);
  const [contadoresSelect1, setContadoresSelect1] = useState(null);
  const [contadoresSelect2, setContadoresSelect2] = useState(null);
  const [tipo, setTipo] = useState("inversor");
  const [datosGrafica, setDatosGrafica] = useState([]);
  const [inversores, setInversores] = useState(null);
  const [contadores, setContadores] = useState(null);
  const [error, setError] = useState(null);
  const [seleccionado1, setSeleccionado1] = useState();
  const [seleccionado2, setSeleccionado2] = useState();
  const [loading, setLoading] = useState(false);
  const [tituloGrafica, setTituloGrafica] = useState(null);

  const selectInversor1 = useRef();
  const selectInversor2 = useRef();
  const fechaInversor1 = useRef();
  const fechaInversor2 = useRef();
  const selectContador1 = useRef();
  const selectContador2 = useRef();

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  useEffect(() => {
    fectchAllInverters();
    fectchAllEnergyMeters();
  }, [huerta]);

  const fectchAllInverters = async () => {
    try {
      const response = await avantSolarApi.get(
        `/admins/allInverters?id_huerta=${huerta}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      if (data?.code == 200) {
        setInversores([...data.data]);
      } else {
      }
    } catch (error) {
      console.log(error.response);
    }
  };

  const fectchAllEnergyMeters = async () => {
    try {
      const response = await avantSolarApi.get(
        `/admins/allCounters?id_huerta=${huerta}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;

      if (data?.code == 200) {
        setContadores([...data.data]);
      } else {
      }
    } catch (error) {
      console.log(error.response);
    }
  };

  useEffect(() => {
    //Para formar los objetos que necesita el componente Select de React-select
    let inver = [];

    inversores?.forEach((valor) => {
      inver.push({
        value: valor.numInversor,
        label: "Inversor " + valor.numInversor,
        color: "#00B8D9",
      });
    });
    setInversoresSelect1(inver);
    setInversoresSelect2(inver);
    setInversoresSelectCopia(inver);
  }, [inversores]);

  useEffect(() => {
    //Para formar los objetos que necesita el componente Select de React-select
    let contad = [];
    contadores?.forEach((valor) => {
      contad.push({
        value: valor.numContador,
        label: "Contador " + valor.numContador,
        color: "#00B8D9",
      });
    });

    setContadoresSelect1(contad);
    setContadoresSelect2(contad);
    setContadoresSelectCopia(contad);
  }, [contadores]);

  const handleChangeSelect = (event, nombre) => {
    if (tipo == "inversor") {
      let nuevosContadores = inversoresSelectCopia?.filter(
        (inversor) => inversor.value != event.value
      );
      if (nombre == "select1") {
        setInversoresSelect2([...nuevosContadores]);
      } else {
        setInversoresSelect1([...nuevosContadores]);
      }
    }

    if (tipo == "contador") {
      let nuevosContadores = contadoresSelectCopia?.filter(
        (inversor) => inversor.value != event.value
      );
      if (nombre == "select1") {
        setContadoresSelect2([...nuevosContadores]);
      } else {
        setContadoresSelect1([...nuevosContadores]);
      }
    }
  };

  //Establecer el tipo de parámetro al hacer la peticion ('Inversor' o 'Contador')
  const handleChangeInversorContador = (event) => {
    if (event.target.value == "contador") {
      setTipo("contador");
    } else {
      setTipo("inversor");
    }
  };

  const handleSubmitForm = (event) => {
    event.preventDefault();

    let consulta;
    if (event.target.dato1.value && event.target.fecha1.value) {
      setSeleccionado1(event.target.dato1.value);
      //Quita las letras y deja solo el número para obtener el id
      let numInversor = event.target.dato1.value.replace(/\D/g, "");

      let anio = event.target.fecha1.value.substring(0, 4);
      let mes = event.target.fecha1.value.substring(5, 7);
      let dia = event.target.fecha1.value.substring(8, 10);
      consulta = `&inversor[0][NumInversor]=${numInversor}&inversor[0][dia]=${dia}&inversor[0][mes]=${mes}&inversor[0][anio]=${anio}`;
    }
    if (event.target.dato2.value && event.target.fecha2.value) {
      setSeleccionado2(event.target.dato2.value);
      let numInversor = event.target.dato2.value.replace(/\D/g, "");

      let anio = event.target.fecha2.value.substring(0, 4);
      let mes = event.target.fecha2.value.substring(5, 7);
      let dia = event.target.fecha2.value.substring(8, 10);
      consulta =
        consulta +
        `&inversor[1][NumInversor]=${numInversor}&inversor[1][dia]=${dia}&inversor[1][mes]=${mes}&inversor[1][anio]=${anio}`;
    }

    if (event.target.dato1.value && event.target.fecha1.value) {
      //Realizar la consulta si el primer input del formulario tiene datos
      consulta = consulta + `&tipo=${tipo}`;

      fetchDatosGrafica(consulta);
    }
  };

  const fetchDatosGrafica = async (consulta) => {
    setError(null);
    setLoading(true);
    try {
      const response = await avantSolarApi.get(
        `/admins/inverterGraphic?id_huerta=${huerta}` + consulta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      console.log(data);
      setLoading(false);

      if (data?.code == 200) {
        setDatosGrafica([...data.data.datos]);

        setTituloGrafica(data.data.tituloGrafica);
        if (data.data.datos.length == 0) {
          setError("No hay datos para esta consulta");
        }
      } else {
        setError(data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const limpiarDatosPrimerInversor = (event) => {
    if (selectInversor1.current) selectInversor1.current.setValue("");
    if (selectContador1.current) selectContador1.current.setValue("");
    fechaInversor1.current.value = "";
  };

  const limpiarDatosSegundoInversor = (event) => {
    if (selectInversor2.current) selectInversor2.current.setValue("");
    if (selectContador2.current) selectContador2.current.setValue("");
    fechaInversor2.current.value = "";
  };

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          <div className="p-2">
            {error && (
              <div style={{ height: `${tamanioGrafica() + 40}px` }}>
                <Alert message={error}></Alert>
              </div>
            )}
            {loading && <SpinnerAvantsolar></SpinnerAvantsolar>}
            {tituloGrafica && (
              <p className="text-center mb-4">{tituloGrafica}</p>
            )}
            {!error && (
              <GraficaPotencia
                seleccionado1={seleccionado1}
                seleccionado2={seleccionado2}
                tipo={tipo}
                datos={datosGrafica}
              />
            )}
          </div>
          <div className="  mt-lg-2">
            <form onSubmit={handleSubmitForm} className="w-100">
              <Row className="w-100 p-0 m-0">
                <Col xs={12} sm={7} className="w-100">
                  <div className="d-flex justify-content-center justify-content-sm-end align-items-center w-100">
                    <label className="d-flex justify-content-center align-items-center mr-2">
                      <span
                        onClick={(event) => limpiarDatosPrimerInversor(event)}
                        className="mdi mdi-reload mr-2 text-secondary"
                      ></span>
                      {tipo == "inversor" && (
                        <Select
                          ref={selectInversor1}
                          required
                          name="dato1"
                          onChange={(event) =>
                            handleChangeSelect(event, "select1")
                          }
                          menuPlacement="top"
                          className="basic-single w-100"
                          classNamePrefix="select"
                          options={inversoresSelect1}
                        />
                      )}
                      {tipo == "contador" && (
                        <Select
                          ref={selectContador1}
                          name="dato1"
                          onChange={(event) =>
                            handleChangeSelect(event, "select1")
                          }
                          menuPlacement="top"
                          className="basic-single w-100"
                          classNamePrefix="select"
                          options={contadoresSelect1}
                        />
                      )}
                    </label>
                    <label className="d-flex justify-content-center align-items-center">
                      <span className="mr-2">Fecha1</span>
                      <input
                        ref={fechaInversor1}
                        max={convertirFechaInputFecha(
                          new Date().toLocaleDateString()
                        )}
                        name="fecha1"
                        required
                        className="w-100 p-1 "
                        type="date"
                      />
                    </label>
                  </div>
                  <div className="d-flex  justify-content-center justify-content-sm-end align-items-center mt-2">
                    <label className="d-flex justify-content-center align-items-center mr-2">
                      <span
                        onClick={(event) => limpiarDatosSegundoInversor(event)}
                        className="mdi mdi-reload mr-2 text-secondary"
                      ></span>
                      {tipo == "inversor" && (
                        <Select
                          ref={selectInversor2}
                          name="dato2"
                          onChange={(event) =>
                            handleChangeSelect(event, "select2")
                          }
                          menuPlacement="top"
                          className="basic-single w-100"
                          classNamePrefix="select"
                          options={inversoresSelect2}
                        />
                      )}
                      {tipo == "contador" && (
                        <Select
                          ref={selectContador2}
                          name="dato2"
                          onChange={(event) =>
                            handleChangeSelect(event, "select2")
                          }
                          menuPlacement="top"
                          className="basic-single w-100"
                          classNamePrefix="select"
                          options={contadoresSelect2}
                        />
                      )}
                    </label>
                    <label className="d-flex justify-content-center align-items-center">
                      <span className="mr-2">Fecha2</span>
                      <input
                        ref={fechaInversor2}
                        max={convertirFechaInputFecha(
                          new Date().toLocaleDateString()
                        )}
                        name="fecha2"
                        className="w-100 p-1"
                        type="date"
                      />
                    </label>
                  </div>
                </Col>

                <Col className="w-100 mt-3 mt-lg-0" xs={12} sm={5}>
                  <div className="d-flex justify-content-center justify-content-sm-start align-items-center w-100">
                    <div className="d-flex justify-content-center align-items-center ">
                      <select
                        defaultValue={"inversor"}
                        onChange={(event) =>
                          handleChangeInversorContador(event)
                        }
                        className="custom-select"
                        name="tipo"
                      >
                        <option value={"inversor"}>Inversores</option>
                        <option value={"contador"}>Contadores</option>
                      </select>

                      <label>
                        <button className="btn btn-primary ml-2">Enviar</button>
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>
            </form>
          </div>
        </div>
        <Footer data={[]} />
      </div>
    </div>
  );
}

export default GraficaPotenciaInversor;
